import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Header } from "./TextsTab";
import { Mail } from "lucide-react";

export default function ContactsTab() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/contacts").then((r) => setItems(r.data)).catch(() => toast.error("Error al cargar mensajes")).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6 max-w-5xl">
      <Header title="Mensajes recibidos" subtitle="Consultas enviadas a través del formulario de contacto." />
      {loading ? <div className="text-[#7da3ff] mono">Cargando…</div> : items.length === 0 ? (
        <div className="glass rounded-2xl p-10 text-center">
          <Mail className="w-10 h-10 text-[#5b73a8] mx-auto mb-3" />
          <div className="text-[#9bb0e0]">Aún no recibiste mensajes.</div>
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((m) => (
            <div key={m.id} className="glass rounded-xl p-5">
              <div className="flex items-center justify-between gap-3 flex-wrap">
                <div className="text-white font-medium">{m.name} {m.company && <span className="text-[#9ec0ff] font-normal">· {m.company}</span>}</div>
                <div className="mono text-[10px] text-[#7da3ff]">{new Date(m.created_at).toLocaleString("es-AR")}</div>
              </div>
              <div className="text-xs text-[#9bb0e0] mt-1">{m.email}{m.phone && <span> · {m.phone}</span>}</div>
              <p className="text-[#cad8ff] mt-3 whitespace-pre-wrap">{m.message}</p>
              <div className="mt-3 flex gap-2 text-xs">
                <a href={`mailto:${m.email}`} className="btn-ghost px-3 py-1.5 rounded-lg">Responder por email</a>
                {m.phone && <a href={`https://wa.me/${m.phone.replace(/\D/g, "")}`} target="_blank" rel="noreferrer" className="btn-ghost px-3 py-1.5 rounded-lg">WhatsApp</a>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
